import { RootState } from "@/app/stores"
import { createGroup, deleteGroup, groupAccrual, IGroup, setVisibilityAcl, getAclList, deleteAcl, IVisibilityAcl, ISetVisibilityAclRequest, TargetType } from "@/shared/api/groups"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchDeleteGroup = createAsyncThunk<
    void,
    void,
    { state: RootState }
>('updateGroup/fetchDeleteGroup', async (_, thunkAPI) => {
    try {
        const { currentGroup } = thunkAPI.getState().updateGroup
        await deleteGroup(currentGroup.id)
        return
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchCreateGroup = createAsyncThunk<
    IGroup,
    string,
    { state: RootState }
>('updateGroup/fetchCreateGroup', async (data, thunkAPI) => {
    try {
        const { currentRole } = thunkAPI.getState().updateGroup
        const group = await createGroup({
            name: data,
            role_id: currentRole
        })
        return group.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

interface IGroupAccrualRequest {
    bonus_id: string,
    amountNano: number
    comment: string,
}

export const fetchGroupAccrual = createAsyncThunk<
    void,
    IGroupAccrualRequest,
    { state: RootState }
>('updateGroup/fetchGroupAccrual', async(data, thunkAPI) => {
    try {
        const { currentGroup } = thunkAPI.getState().updateGroup
        const response = await groupAccrual(currentGroup.id, {
            bonus_id: data.bonus_id,
            amount_nano: data.amountNano,
            comment: data.comment,
        }) 
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchSetVisibilityAcl = createAsyncThunk<
    IVisibilityAcl,
    ISetVisibilityAclRequest,
    { state: RootState }
>('updateGroup/fetchSetVisibilityAcl', async (data, thunkAPI) => {
    try {
        const response = await setVisibilityAcl(data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchGetAclList = createAsyncThunk<
    IVisibilityAcl[],
    void,
    { state: RootState }
>('updateGroup/fetchGetAclList', async (_, thunkAPI) => {
    try {
        const { currentGroup, currentUser, visibilityAclSourceType } = thunkAPI.getState().updateGroup
        
        if (visibilityAclSourceType === TargetType.USER && currentUser) {
            const response = await getAclList({
                target_type: TargetType.USER,
                target_id: currentUser.id
            })
            return response.data
        } else if (visibilityAclSourceType === TargetType.GROUP && currentGroup.id) {
            const response = await getAclList({
                target_type: TargetType.GROUP,
                target_id: currentGroup.id
            })
            return response.data
        }
        
        return []
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchDeleteAcl = createAsyncThunk<
    void,
    string,
    { state: RootState }
>('updateGroup/fetchDeleteAcl', async (acl_id, thunkAPI) => {
    try {
        await deleteAcl(acl_id)
        return
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})